//#region Imports
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
//#endregion

//#region General Information
import { SolidarityAddressComponent } from 'src/app/views/general-information/solidarity-address/solidarity-address.component';
import { AddressComponent } from 'src/app/views/general-information/address/address.component';
import { HouseApartmentComponent } from 'src/app/views/general-information/house-apartment/house-apartment.component';
import { OwnerTenantComponent } from 'src/app/views/general-information/owner-tenant/owner-tenant.component';
import { PrimarySecondaryComponent } from 'src/app/views/general-information/primary-secondary/primary-secondary.component';
import { PreferentialRateComponent } from 'src/app/views/general-information/preferential-rate/preferential-rate.component';
import { NumberPiecesComponent } from 'src/app/views/general-information/number-pieces/number-pieces.component';
import { PreviousClaimComponent } from 'src/app/views/general-information/previous-claim/previous-claim.component';
import { DependencyComponent } from 'src/app/views/general-information/dependency/dependency.component';
import { ParticularityComponent } from 'src/app/views/general-information/particularity/particularity.component';
import { InsuredValueComponent } from 'src/app/views/general-information/insured-value/insured-value.component';
//#endregion

//#region Devis
import { SubscriberComponent } from 'src/app/views/devis/subscriber/subscriber.component';
import { RateComponent } from 'src/app/views/devis/rate/rate.component';
import { OfferCustomizationComponent } from 'src/app/views/devis/offer-customization/offer-customization.component';
import { SchoolInsuranceComponent } from 'src/app/views/devis/school-insurance/school-insurance.component';
import { QuoteConfirmationComponent } from 'src/app/views/devis/quote-confirmation/quote-confirmation.component';
//#endregion

//#region Contract
import { ServicesComponent } from 'src/app/views/contract/services/services.component';
import { CancellationComponent } from 'src/app/views/contract/cancellation/cancellation.component';
import { PaymentComponent } from 'src/app/views/contract/payment/payment.component';
import { ElectronicSignatureComponent } from 'src/app/views/contract/electronic-signature/electronic-signature.component';
import { ContractConfirmationComponent } from 'src/app/views/contract/contract-confirmation/contract-confirmation.component';
import { LessorCertificateComponent } from 'src/app/views/contract/lessor-certificate/lessor-certificate.component';
import { RedirectComponent } from '../components/redirect/redirect.component';
import { LayoutComponent } from '../components/layout/layout.component';
import { SignatureGuard } from '../guards/signature.guard';

//#endregion

const routes: Routes = [
  {
    path: '',
    canActivate: [SignatureGuard],
    canActivateChild: [SignatureGuard],
    component: LayoutComponent,
    children: [
      { path: 'solidarityaddress', component: SolidarityAddressComponent },
      { path: 'address', component: AddressComponent },
      { path: 'ownertenant', component: OwnerTenantComponent },
      { path: 'primarysecondary', component: PrimarySecondaryComponent },
      { path: 'preferentialrate', component: PreferentialRateComponent },
      { path: 'previousclaim', component: PreviousClaimComponent },
      { path: 'dependency', component: DependencyComponent },
      { path: 'subscriber', component: SubscriberComponent },
      { path: 'rate', component: RateComponent },
      { path: 'services', component: ServicesComponent }
    ]
  },
  {
    path: 'houseapartment',
    component: HouseApartmentComponent,
    canActivate: [SignatureGuard],
    canActivateChild: [SignatureGuard]
  },
  {
    path: 'numberpieces',
    component: NumberPiecesComponent,
    canActivate: [SignatureGuard],
    canActivateChild: [SignatureGuard]
  },
  {
    path: 'start/:context/:product',
    component: RedirectComponent,
    canActivate: [SignatureGuard],
    canActivateChild: [SignatureGuard]
  },
  {
    path: 'start/:context',
    component: RedirectComponent,
    canActivate: [SignatureGuard],
    canActivateChild: [SignatureGuard]
  },
  {
    path: 'solidarityaddress',
    component: SolidarityAddressComponent,
    canActivate: [SignatureGuard],
    canActivateChild: [SignatureGuard]
  },
  {
    path: 'particularity',
    component: ParticularityComponent,
    canActivate: [SignatureGuard],
    canActivateChild: [SignatureGuard]
  },
  {
    path: 'insuredvalue',
    component: InsuredValueComponent,
    canActivate: [SignatureGuard],
    canActivateChild: [SignatureGuard]
  },
  {
    path: 'rate',
    component: RateComponent,
    canActivate: [SignatureGuard],
    canActivateChild: [SignatureGuard]
  },
  {
    path: 'offercustomization',
    component: OfferCustomizationComponent,
    canActivate: [SignatureGuard],
    canActivateChild: [SignatureGuard]
  },
  {
    path: 'schoolinsurance',
    component: SchoolInsuranceComponent,
    canActivate: [SignatureGuard],
    canActivateChild: [SignatureGuard]
  },
  {
    path: 'confirmquote',
    component: QuoteConfirmationComponent,
    canActivate: [SignatureGuard],
    canActivateChild: [SignatureGuard]
  },
  {
    path: 'services',
    component: ServicesComponent,
    canActivate: [SignatureGuard],
    canActivateChild: [SignatureGuard]
  },
  {
    path: 'lessorcertificate',
    component: LessorCertificateComponent,
    canActivate: [SignatureGuard],
    canActivateChild: [SignatureGuard]
  },
  {
    path: 'cancellation',
    component: CancellationComponent,
    canActivate: [SignatureGuard],
    canActivateChild: [SignatureGuard]
  },
  {
    path: 'payment',
    component: PaymentComponent,
    canActivate: [SignatureGuard],
    canActivateChild: [SignatureGuard]
  },
  {
    path: 'electronicsignature',
    component: ElectronicSignatureComponent,
    canActivate: [SignatureGuard],
    canActivateChild: [SignatureGuard]
  },
  {
    path: 'confirmcontract',
    component: ContractConfirmationComponent,
    canActivate: [SignatureGuard],
    canActivateChild: [SignatureGuard]
  },
  { path: '**', redirectTo: 'error404' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
